<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Product')" style="position:relative">
          <b-form
            @submit.prevent="onSubmitDetails"
            autocomplete="off"
            ref="det"
          >
            <FloatingLabel
              v-model="details.name"
              label="Name"
              autocomplete="false"
              size="sm"
            />

            <FloatingLabel
              v-model="details.description"
              label="Description"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <b-form-group
              :label="$t('Report To ONJN')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >
              <b-form-checkbox
                v-model="details.report_to_onjn"
                :value="true"
                :unchecked-value="false"
                >{{ $t("Activated") }}</b-form-checkbox
              >
            </b-form-group>

            <b-form-group
              :label="$t('Z Include')"
              class="grouping py-2 px-3 mb-3 mt-0"
            >
              <b-form-checkbox
                v-model="details.z_include"
                :value="true"
                :unchecked-value="false"
                >{{ $t("Activated") }}</b-form-checkbox
              >
            </b-form-group>

            <div style="text-align:right">
              <b-dropdown
                variant="success"
                right
                split
                :text="$t('Save')"
                @click="onSubmitDetails"
              >
                <b-dropdown-item @click="saveAsNew">{{
                  $t("Save As New")
                }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "@/components/multiselect-filters";
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";

export default {
  name: "product",
  props: ["selectedeid"],
  components: {
    Multiselect,
    FloatingLabel
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
      this.newId = true;
    }

    this.loadData();
  },
  data: function() {
    return {
      eid: "",
      details: {
        name: "",
        description: "",
        report_to_onjn: false,
        z_include: false
      },
      newId: false,

      temp: {}
    };
  },
  methods: {
    loadData() {
      if (this.eid == "") {
        // new role; nothing to load
        return;
      }
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      this.$store
        .dispatch("product/read", this.eid)
        .then(resp => {
          this.temp = resp.data;
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    saveAsNew() {
      this.eid = "";
      this.newId = true;
      this.onSubmitDetails();
    },
    onSubmitDetails() {
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "product/update";
      if (this.newId) {
        apiAction = "product/create";
      } else {
        detailsData.eid = this.eid;
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Product updated";
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Product created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";
      this.details.name = r.name;
      this.details.description = r.description;
      this.details.report_to_onjn = r.report_to_onjn ? true : false;
      this.details.z_include = r.z_include ? true : false;
    },
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Product", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped></style>
